import { Howl } from 'howler';
import { soundsStore } from '@bg-shared/business/Sounds';
import { uaParser } from '@betgames/bg-tools';

enum CasinoSounds {
    PLACE_CHIP = 'place_chip',
    PLACE_CHIPS = 'place_chips',
    REMOVE_CHIP = 'remove_chip',
    TRAILING = 'trailing',
}

export default class CasinoSoundsService {
    private readonly sounds = new Map<CasinoSounds, Howl>();

    private getOrCreate(sound: CasinoSounds): Howl {
        if (!this.sounds.has(sound)) {
            const srcBase = `/static/shared/sounds/casino/${sound}`;
            const src = ['.webm', '.mp3'].map((ext) => `${srcBase}${ext}`);

            this.sounds.set(
                sound,
                new Howl({
                    src,
                    mute: soundsStore.gameSoundsMuted,
                    html5: uaParser.isIOS,
                }),
            );
        }

        return this.sounds.get(sound);
    }

    constructor() {
        soundsStore.subscribe(({ gameSoundsMuted }) => {
            this.sounds.forEach((sound) => sound.mute(gameSoundsMuted));
        });
    }

    public playPlaceChip(): void {
        this.getOrCreate(CasinoSounds.PLACE_CHIP).play();
    }

    public playPlaceChips(): void {
        this.getOrCreate(CasinoSounds.PLACE_CHIPS).play();
    }

    public playRemoveChip(): void {
        this.getOrCreate(CasinoSounds.REMOVE_CHIP).play();
    }

    public playTrailing(): void {
        this.getOrCreate(CasinoSounds.TRAILING).play();
    }

    public stop(): void {
        this.sounds.forEach((sound) => sound.stop());
    }
}

export const casinoSoundsService = new CasinoSoundsService();
